import React, { useState } from 'react';
import '../styles/ContactUs.css';

const ContactUs = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [pdfFile, setPdfFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      if (file.size > 30 * 1024 * 1024) {
        setErrors((prev) => ({ ...prev, pdfFile: 'File size must be under 30MB.' }));
        setPdfFile(null);
      } else {
        setPdfFile(file);
        setErrors((prev) => ({ ...prev, pdfFile: null }));
      }
    } else {
      setPdfFile(null);
      setErrors((prev) => ({ ...prev, pdfFile: 'Only PDF files are allowed.' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = 'Name is required.';
    if (!form.email.trim()) newErrors.email = 'Email is required.';
    else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(form.email))
      newErrors.email = 'Invalid email format.';
    if (!form.message.trim()) newErrors.message = 'Message is required.';
    if (!pdfFile) newErrors.pdfFile = 'Please upload a PDF document.';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validateForm()) return;

  const formData = new FormData();
  formData.append('name', form.name);
  formData.append('email', form.email);
  formData.append('phone', form.phone);
  formData.append('message', form.message);
  formData.append('pdfFile', pdfFile);

  try {
    const res = await fetch('http://localhost:8080/myprojects/send-form.php', {
    // const res = await fetch('https://tmccontractors.net/send-form.php', {
      method: 'POST',
      body: formData,
    });
console.log('Sending form data:', {
  ...formData,
  file: pdfFile?.name,
});
    if (res.ok) {
      setSubmitted(true);
      setForm("");
      console.log(setSubmitted);
      
      console.log('Email sent');
    } else {
      console.error('Failed to send');
    }
  } catch (err) {
    console.error('Error submitting:', err);
  }
};

  return (
    <section className="contact-section">
      <div className="contact-heading-area">
        <h2 className="section-title">Contact Us</h2>
        <p className="section-subtitle">We'd love to hear about your project.</p>
      </div>

      <div className="contact-grid">
        {/* Contact Form */}
        <div className="contact-form-wrapper">
          <form onSubmit={handleSubmit} className="contact-form">
            <label>
              Name<span className="required">*</span>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your name"
              />
              {errors.name && <span className="error">{errors.name}</span>}
            </label>

            <label>
              Email<span className="required">*</span>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
              />
              {errors.email && <span className="error">{errors.email}</span>}
            </label>

            <label>
              Phone
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="(Optional)"
              />
            </label>

            <label>
              Message<span className="required">*</span>
              <textarea
                name="message"
                rows="5"
                value={form.message}
                onChange={handleChange}
                placeholder="Tell us about your project..."
              />
              {errors.message && <span className="error">{errors.message}</span>}
            </label>

            <label>
              Upload PDF<span className="required">*</span>
              <input type="file" accept="application/pdf" onChange={handleFileChange} />
              {errors.pdfFile && <span className="error">{errors.pdfFile}</span>}
              {pdfFile && <p className="file-preview">Selected: {pdfFile.name}</p>}
            </label>

            <button type="submit" className="submit-button" disabled={submitted}>
              {submitted ? 'Submitted' : 'Send Message'}
            </button>

            {submitted && (
              <p className="success-message">Thank you! We'll be in touch shortly.</p>
            )}
          </form>
        </div>

        {/* Office Information */}
        <div className="contact-info-wrapper">
          <h3 className="info-title">Let’s Chat!</h3>
          <p className="info-description">
            Reach out via form or call us directly. We're here to help with all your project needs.
          </p>

          <div className="office-info-card">
            <h4>Indianapolis Office</h4>
            <p>4151 Kessler Blvd E Dr, Indianapolis, IN 46220</p>
            <a href="tel:18888629190">1-888-862-9190</a>
          </div>

          <div className="office-info-card">
            <h4>NW Indiana Office</h4>
            <p>401 S Hamilton St, Gary, IN 46403</p>
            <a href="tel:18888629190">1-888-862-9190</a>
          </div>
        </div>
      </div>

      <p className="recaptcha-note">
        Protected by reCAPTCHA. See Google's{' '}
        <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
          Privacy Policy
        </a>{' '}
        and{' '}
        <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">
          Terms of Service
        </a>.
      </p>
    </section>
  );
};

export default ContactUs;
